module.exports = __webpack_public_path__ + "img/105004.a488566b.png";